'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _pcSlateTools = require('./../../process/pc-slate-tools');

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _ShopifySection = require('./../ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = '[data-recently-viewed]'; /*
                                                    *  Recently Viewed Peoducts
                                                    *
                                                    *
                                                    *  Version:
                                                    *    1.0.0 - 2020/08/11
                                                    */

var THUMBNAIL_TEMPLATE = '[data-recently-viewed-thumbnail]';
var CAROUSEL_SELECTOR = '[data-recently-viewed-loop]';

var RecentlyViewed = function (_CarouselSection) {
  (0, _inherits3.default)(RecentlyViewed, _CarouselSection);

  function RecentlyViewed(container) {
    (0, _classCallCheck3.default)(this, RecentlyViewed);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RecentlyViewed.__proto__ || Object.getPrototypeOf(RecentlyViewed)).call(this, container));

    _this.thumbnailTemplate = container.find(THUMBNAIL_TEMPLATE).html();
    _this.carouselSelector = container.find(CAROUSEL_SELECTOR);
    _this.cookies = 'recently_viewed';
    //console.log(Cookies.get(this.cookies));
    if (!_jsCookie2.default || _jsCookie2.default.get(_this.cookies) == undefined) return (0, _possibleConstructorReturn3.default)(_this);
    _this.products = JSON.parse(_jsCookie2.default.get(_this.cookies));

    _this.productsPrint = _this.products.map(function (p) {
      if (p.variants == undefined) return;
      var v = p.variants[0];
      var templ = (0, _jquery2.default)(_this.thumbnailTemplate);
      templ.find('[data-url]').attr('href', p.url);
      templ.find('[data-image]').html((0, _pcSlateTools.generatePicture)(p.image, 300, [150, 300]));
      templ.find('[data-title]').html(p.title);
      templ.find('[data-price]').html((0, _pcSlateTools.printMoney)(v.price)).attr('data-money', v.price);
      return templ;
    });

    _this.carouselSelector.html(_this.productsPrint);

    _this.slick = _this.initCarousel(_this.carouselSelector);
    return _this;
  }

  return RecentlyViewed;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, RecentlyViewed);